<div class="wallet-binding-callback-container">
  <div class="wallet-binding-callback-content">
    <p-progress-spinner
    *ngIf="isLoading" 
    fill="transparent" 
    animationDuration="1s"
    styleClass="spinner-blue" 
    [style]="{ width: '64px', height: '64px' }" />
  </div>
</div>